import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { tokens } from '@hotjar/hotsauce';

const TableWrapper = styled.table<{ templateColumns: string }>`
  display: grid;
  grid-template-columns: ${(p) => p.templateColumns};
`;

interface TableProps {
  templateColumns: string;
  children: React.ReactNode;
}

export function Table({ children, templateColumns }: TableProps): JSX.Element {
  return <TableWrapper templateColumns={templateColumns}>{children}</TableWrapper>;
}

export const Head = styled.thead`
  display: contents;
`;

export const Body = styled.tbody`
  display: contents;
`;

export const Cell = styled.td<{ align?: 'right' | 'left' | 'center' }>`
  ${tokens.text('body2')}
  margin: 0;
  padding: ${tokens.spacer.x1} ${tokens.spacer.x2};
  border-bottom: 1px solid ${tokens.color.ui_border};
  text-align: ${(p) => p.align ?? 'left'};
`;

const HeaderWrapper = styled(Cell)`
  ${tokens.text('caption')}
  font-weight: 600;
  border-bottom-color: ${tokens.color.ui_border};
`;

export function Header(props: { children: React.ReactNode }): JSX.Element {
  return <HeaderWrapper as="th" {...props} />;
}

export const Row = styled.tr<{ hover?: boolean }>`
  display: contents;

  ${({ hover }) =>
    hover &&
    css`
      &:hover {
        ${Cell}, td, th {
          background-color: ${tokens.color.neutral_100};
        }
      }
    `};
`;
